import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const QUOTES = [
  {
    name: "Aarav Mehta",
    role: "Founder, D2C beauty (Mumbai)",
    body:
      "Lemonsqueezy didn’t just run our ads — they fixed our funnel, our store and our retention. ROAS doubled in the first quarter and stayed there.",
  },
  {
    name: "Priya Iyer",
    role: "VP Marketing, B2B SaaS (Bengaluru)",
    body:
      "Their ABM playbook is the cleanest we’ve seen in India. SDRs finally had a steady drip of accounts that actually picked up the phone.",
  },
  {
    name: "Rohan Kapoor",
    role: "Director, QSR chain (Pune)",
    body:
      "We were leaking customers between orders. Their WhatsApp + email lifecycle work brought repeat-order behaviour back, fast.",
  },
  {
    name: "Sneha Rao",
    role: "Co-founder, wellness D2C (Delhi)",
    body:
      "From Amazon SmartBiz to our Shopify rebuild — one team, one roadmap, zero finger-pointing. That’s rare in this market.",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-zinc-950"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <p className="text-yellow-400 font-mono-ui text-xs tracking-[0.22em] uppercase mb-4">
            · Founders & marketers say
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter">
            Real words.
            <br />
            <span className="text-zinc-500"></span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {QUOTES.map((q, idx) => (
            <motion.div
              key={q.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="relative rounded-2xl border border-white/10 bg-zinc-900/40 p-7 sm:p-8 hover:border-yellow-400/30 transition-all"
              data-testid={`testimonial-${idx}`}
            >
              <Quote
                size={28}
                className="text-yellow-400/70 mb-4"
                strokeWidth={2.2}
              />
              <p className="text-zinc-200 text-lg leading-relaxed">
                “{q.body}”
              </p>
              <div className="mt-6 flex items-center gap-4">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 text-zinc-950 font-display font-bold flex items-center justify-center">
                  {q.name
                    .split(" ")
                    .map((s) => s[0])
                    .join("")
                    .slice(0, 2)}
                </div>
                <div>
                  <div className="text-zinc-100 font-medium">{q.name}</div>
                  <div className="text-zinc-500 text-sm">{q.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
